module.exports = __webpack_public_path__ + "img/profil_blank.1443505f.png";